import TablePagination from "@mui/material/TablePagination";

export function RopTablePageSS(props: {
  hasNextPage: boolean;
  rowsPerPage: number;
  pageIndex: number;
  page: number;
  setPage: (page: number) => void;
  setRowsPerPage: (rowsPerPage: number) => void;
}) {
  const { rowsPerPage, pageIndex, page, setPage, setRowsPerPage, hasNextPage } =
    props;
  const totalRegisters = hasNextPage
    ? page * rowsPerPage + page
    : page * rowsPerPage;
  return (
    <TablePagination
      rowsPerPageOptions={[10, 25, 100]}
      labelRowsPerPage="Itens por página"
      showFirstButton
      labelDisplayedRows={({ from, to }) => `${from}-${to}`}
      component="div"
      sx={{
        "& .MuiTablePagination-selectLabel": {
          margin: 0,
          display: { md: "block", xs: "none" },
        },
        "& .MuiTablePagination-displayedRows": {
          margin: 0,
        },
        "& .MuiInputBase-root": {
          display: { md: "block", xs: "none" },
        },
      }}
      count={totalRegisters}
      rowsPerPage={rowsPerPage}
      page={pageIndex}
      onPageChange={(_, page) => {
        setPage(page);
      }}
      onRowsPerPageChange={(e) => {
        setPage(0);
        setRowsPerPage(Number(e.target.value));
      }}
    />
  );
}
